import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { Title } from "@angular/platform-browser";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { IncomeWealthService } from "../../service/income-wealth.service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { NifCountriesService } from "../../../shared/service/nif-countries/nif-countries.service";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
@Component({
  selector: "app-nif",
  templateUrl: "./nif.component.html",
  styleUrls: ["./nif.component.scss"],
})
export class NifComponent extends DefaultPageComponent implements OnInit {
  idLabelNif = "idLabelNif";
  idInputNif = "documentNif";
  idButtonNif = "idButtonNif";
  nif = "";
  taxResidency: string;
  error = false;
  buttonEnable = true;
  textError = "Número inválido";
  headerId = "income-nif";
  titlePage = "Renda e patrimônio";
  startStage = "2";
  endStage = "3";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  selectedCountry: any = {};
  nifForm: FormGroup;
  formatType: string;
  minLength: number;
  maxLength: number;
  type = "text";
  lengthValues: "";

  constructor(
    public router: NavController,
    public incomeWealthService: IncomeWealthService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService,
    private nifCountriesService: NifCountriesService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.setTaxResidency();
    this.editFieldInvest("numero_identificacao_fiscal", "nif", "income");
    this.getTrack();
    this.initializeNifForm();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    // tslint:disable-next-line:variable-name
    const it_pagename = this.analyticsPage.nif;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathNumeroNif,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    this.incomeWealthService.setNif(this.nif);
    this.nextPage();
  }

  analyticsEventClique() {
    // tslint:disable-next-line:variable-name
    const it_eventcategory = "Clique";
    // tslint:disable-next-line:variable-name
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.nif,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  errorMsg() {
    const control = this.nifForm.controls.nif;
    this.error = control.errors !== null;

    this.error ? (this.buttonEnable = false) : (this.buttonEnable = true);

    if (
      !this.selectedCountry.preenchimento_obrigatorio &&
      this.nif.length === 0
    ) {
      this.error = false;
      this.buttonEnable = true;
    }

    if (control.errors?.required && this.nif.length === 0) {
      this.textError = "Preenchimento obrigatório";
    }
    if (
      control.errors?.minlength?.actualLength <=
        control.errors?.minlength?.requiredLength &&
      this.nif.length !== 0
    ) {
      this.textError = "Digite no mínimo " + this.minLength + " caracteres";
    }
    if (control.errors?.onlyNumbers && this.nif.length !== 0) {
      this.textError = "Digite apenas números";
    }
    if (control.errors?.alphanumeric && this.nif.length !== 0) {
      this.textError = "Digite apenas letras e números";
    }
    if (control.errors?.charactersNotAllowed && this.nif.length !== 0) {
      this.textError = "Caracteres especiais não permitidos";
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setTaxResidency() {
    this.taxResidency =
      this.journeyService.registratioJourney.data.incomeEquity.taxResidenceName?.toLocaleUpperCase();
  }

  initializeNifForm() {
    this.nifCountriesService.getListNifCountries().subscribe((countries) => {
      // Recupera lista de países e retorna os campos adicionais do país selecionado
      this.selectedCountry = countries.find(
        (country) => country.value === this.taxResidency
      )?.additionalFields[0]?.validacoes_nif;

      // Cria regras de tamanho permitido
      const lengthValues = this.selectedCountry.tamanhos_permitidos
        .split(";")
        .map(Number);

      this.minLength =
        this.selectedCountry.minimo_caracteres === 0
          ? Math.min(...lengthValues)
          : this.selectedCountry.minimo_caracteres;

      this.maxLength =
        this.selectedCountry.maximo_caracteres === 0
          ? Math.max(...lengthValues)
          : this.selectedCountry.maximo_caracteres;

      if (this.selectedCountry.formato === "SOMENTE_NUMEROS") {
        this.type = "tel";
      }
      // Monta o form
      this.nifForm = this.formBuilder.group({
        nif: [
          "",
          [
            // Aplica as regras de formato de cada país
            Validators.required,
            (control) =>
              FormValidations.validationsNifFormat(
                this.selectedCountry.formato,
                control,
                this.selectedCountry?.caracteres_especiais_nao_permitidos
              ),
          ],
        ],
      });
    });
  }

  allowedLengthSize(): boolean {
    // Aplica a regra de disable no botão caso os tamanhos permitidos não estejam definidos
    const lengthSize = this.nifForm.controls["nif"].value.length;
    this.lengthValues = this.selectedCountry.tamanhos_permitidos
      .split(";")
      .map(Number);

    return (
      this.lengthValues.includes(lengthSize) ||
      (lengthSize >= this.selectedCountry.minimo_caracteres &&
        lengthSize <= this.selectedCountry.maximo_caracteres)
    );
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.incomeEquity.nif) {
      this.nif = this.journeyService.registratioJourney.data.incomeEquity.nif;
      this.nifForm.controls.nif.setValue(this.nif);
      this.errorMsg();
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;

    if (track.getName() === TrackTypes.UPDATE_REGISTRATION) {
      this.startStage = "";
      this.endStage = "";
    }
  }
}
